export default function ToggleSwitch({ checked, onChange }: { checked: boolean; onChange: (val: boolean) => void }) {
  return (
    <button
      type="button"
      onClick={() => onChange(!checked)}
      className={`tw-relative tw-inline-flex tw-w-9 tw-h-5 tw-rounded-full tw-transition-colors tw-duration-200 tw-border-0 tw-flex-shrink-0 ${
        checked ? "tw-bg-blue-500" : "tw-bg-gray-300"
      }`}
    >
      <span
        className={`tw-absolute tw-top-0.5 tw-left-0.5 tw-w-4 tw-h-4 tw-bg-white tw-rounded-full tw-shadow tw-transition-transform tw-duration-200 ${
          checked ? "tw-translate-x-[18px]" : "tw-translate-x-0"
        }`}
      />
    </button>
  );
}
